//////////////////////////////////////////////////////////////////////////////////
//
// LIT Discovery
// An extensible search & discovery module for UBC Library applications.
//
// Schuyler Lindberg and Jenna Zhen, 2019
//
//////////////////////////////////////////////////////////////////////////////////

// App Dependencies
// import "core-js/stable"; // webpack/babel 'useBuiltIns' will pare this down to what's needed
// import "regenerator-runtime/runtime";
import { createWebHistory, createRouter } from 'vue-router'

// Globals installed by plugin
import { eventBus } from './vue/event-bus';  // replace/update for vue3
import advSearch from './js/advancedSearch';  
import apiSearch from './js/apiSearch';
import facetFilters from './js/facetFilters';

// VUE COMPONENTS
// base component  -- you must import this.
import searchBase from './vue/search-base.vue';

// VUE PLUGIN
// plugin installs lit-discovery global components.
const plugin = {
  install(app, options) {

    // OPTIONS
    // required
    // set global search app options (see config-example.js)
    app.config.globalProperties.$searchOpts = options.searchOpts;  // import where needed?
    // set global search fields (see fields-example.js)
    app.config.globalProperties.$searchFields = options.fields; // import where needed?
    // optional
    // app entry point 
    const searchComponent = (options.searchComponent) ? options.searchComponent : searchBase;

    // event-bus for propagating events across components
    app.config.globalProperties.$eventBus = eventBus;

    // search functionality
    // intialize
    // advSearch.initFields(options.fields.sourceFields);  

    // todo: move global search composable and/or import where needed.
    app.config.globalProperties.$apiSearch = (options.apiSearch) ? options.apiSearch : apiSearch;  // replace the search API module if you want to
    // app.config.globalProperties.$advSearch = advSearch; // move adv search to composable

    // console.log('global config', app.config.globalProperties)

    // global computed properties (replacing filters from vue2)
    // ===============================================

    app.config.globalProperties.$filters = {
      capitalize(value) {
        if (!value) return '';
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
    
      joinArray(value) {
        if (value && Array.isArray(value)) {
          return value.join(', ');
        } else {
          return value;
        }
      },
    
      truncate(value, length) {
        let len = length || 200;
        if (value && value.length > len) {
          value = value.substring(0, len) + '...';
        }
        return value;
      },
    
      dateFormatYear(value) {
        const date = new Date(value);
        return date.getFullYear();
      }
    }

    //===========================================================================
    // use app router and set up routes
    const routes = [
      {
        path: '/', 
        name: "search",
        component: searchComponent, 
        props: true // Pass route.params to props
      }, 
      {
        path: '/advanced',
        name: 'search-advanced',
        component: searchComponent, 
        props: true // Pass route.params to props
      }, 
    ]
    const router = createRouter({
      history: createWebHistory("/search/"),
      routes: routes
    });

    app.use(router);
  }
}

export {
  plugin as default,
};
